import React, { useState } from 'react';
import { Send, CheckCircle2, AlertCircle } from 'lucide-react';
import { newsletterApi } from '../lib/api';
import { Input } from './ui/input';
import { useI18n } from '../context/I18nContext';
import UI from '../lib/uiCatalog';

export default function NewsletterForm() {
  const { t } = useI18n();
  const T = (k) => t(k, UI[k]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!name.trim()) { return setError('Name is required'); }
    if (!email.trim()) { return setError('Email is required'); }
    setBusy(true);
    try {
      await newsletterApi.subscribe({ name: name.trim(), email });
      setDone(true);
      setName(''); setEmail('');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Could not subscribe');
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-emerald-300 text-sm">
        <CheckCircle2 size={16} /> {T('footer.newsletter_thanks')}
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-2">
      <Input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={T('footer.newsletter_name')}
        className="bg-white/10 border-white/20 text-white placeholder:text-slate-400 h-10"
        data-testid="newsletter-name"
      />
      <div className="flex items-center gap-2">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={T('footer.newsletter_email')}
          className="bg-white/10 border-white/20 text-white placeholder:text-slate-400 h-10"
          data-testid="newsletter-email"
        />
        <button type="submit" disabled={busy} className="h-10 px-4 rounded-full bg-white text-[#0d3a8a] font-semibold text-sm inline-flex items-center gap-1 hover:bg-slate-100 transition-colors disabled:opacity-60 whitespace-nowrap" data-testid="newsletter-submit">
          <Send size={14} /> {busy ? '...' : T('footer.newsletter_button')}
        </button>
      </div>
      {error && (
        <p className="text-rose-300 text-xs inline-flex items-center gap-1">
          <AlertCircle size={12} /> {error}
        </p>
      )}
    </form>
  );
}
